import { render, staticRenderFns } from "./SegurosForm.vue?vue&type=template&id=55378208&scoped=true&"
import script from "./SegurosForm.vue?vue&type=script&lang=js&"
export * from "./SegurosForm.vue?vue&type=script&lang=js&"
import style0 from "./SegurosForm.vue?vue&type=style&index=0&id=55378208&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55378208",
  null
  
)

export default component.exports